import { useEffect, useState } from 'react'

/** Below this width, list views switch from table rows to cards (see CraftsmanRequestsTable) -
 *  must stay in sync with the matching breakpoint in App.css. Rendering only one of the two
 *  markups (rather than both plus CSS display:none) avoids duplicate interactive elements for
 *  screen readers and keyboard navigation. */
const MOBILE_BREAKPOINT_QUERY = '(max-width: 720px)'

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches)

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_BREAKPOINT_QUERY)
    const listener = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mql.addEventListener('change', listener)
    return () => mql.removeEventListener('change', listener)
  }, [])

  return isMobile
}
